import { render } from "./SaveClaimExpenseType.vue?vue&type=template&id=eec81cf0&scoped=true"
import script from "./SaveClaimExpenseType.vue?vue&type=script&lang=js"
export * from "./SaveClaimExpenseType.vue?vue&type=script&lang=js"

import "../save-claim-event.scss?vue&type=style&index=0&id=eec81cf0&lang=scss&scoped=true"

import exportComponent from "/home/user/AIF_Orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eec81cf0"]])

export default __exports__